import createTypes from 'redux-create-action-types';

export default createTypes(
  'GET_FORMS_MSAS',
  'UPDATE_FORMS_MSA',
  'UPDATE_FORMS_MSA_STATUS',
  'SYNC_UPDATE_MSAS'
);
